import { Box, Typography } from '@mui/material';

import { FHConfirmDialog } from '../../../../../../../components/base';
import { FORTA_GRAY5 } from '../../../../../../../utils/colors';
import { INSURANCE_TYPE_TITLES } from '../constants';

import type { InsuranceExtractionOverwriteConfirmModalProps } from './types';

export default function InsuranceExtractionOverwriteConfirmModal({
  insuranceType,
  onClose,
  onSubmit,
}: InsuranceExtractionOverwriteConfirmModalProps) {
  return (
    <FHConfirmDialog
      open
      title="Fill details from this card?"
      submittext="Continue"
      canceltext="Cancel"
      onClose={onClose}
      onSubmit={onSubmit}
      dialogHeight="auto"
      footerContainerStyles={{ mt: 4 }}
      contentRenderer={() => (
        <Box sx={{ pt: 1 }}>
          <Typography sx={{ color: FORTA_GRAY5, fontSize: 14 }}>
            We can read the uploaded card and fill in the {INSURANCE_TYPE_TITLES[insuranceType]}{' '}
            details for you. This may overwrite some of the insurance information you have already
            entered.
          </Typography>
        </Box>
      )}
    />
  );
}
